<template>

  <div style="display: flex;flex-direction: column;justify-content: start">

    <div class="tabsCell" v-for="(item,index) in mTabs" :key="index"
         :class="{activeClass:activeTab==index?true:false, nomalClass:activeTab==index?false:true}"

         @click="clicked(index,item)">
      <span class="cell_label">{{item.title}}</span>
    </div>



  </div>

</template>

<script>
  export default {
    name: "IHSingleVerticalTabs",
    props:{
      mTabs:{
        type: Array,
        required:true,
        default:function () {
          return [
          ];
        }
      },
      activeTab:{
        type: Number,
        required:false,
        default:function () {
          return 0;
        }
      }
    },
    data(){
      return {
        mmm:"&#xe663;",
        backgroundColor_active:"rgb(103,128,158)",
        backgroundColor_normal:"white",
      };
    },
    mounted() {

    },
    methods:{

      clicked:function (index,item) {
        this.activeTab = index;
        this.$emit("tabChanged",item.mCode);
      },

      classObject: function (item) {
        let codeKey = item.icon;
        let obj = {};
        obj[codeKey] = true;
        return obj;
      }
    },
    computed:{

    }
  }
</script>

<style scoped lang="scss">


  .activeClass
  {
    border-right: 5px solid rgb(64,158,255);
    color: rgb(64,158,255);
    font-weight: normal;
  }

  .nomalClass
  {
    color: black;
    border-right: none;
    font-weight: normal;
  }
  .cell_label{
    font-size: 18px;
    word-break:
    break-word;
    text-align: left;
    width: 94%;
    margin-left: 3%;
    background-color: transparent;

  }
  .tabsCell
  {
    width: 99%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background-color: white;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/components/widgets/IHSignalVerticalTabs.vue